import * as React from 'react';
import styled from 'styled-components';

export const styles: { [key: string]: React.CSSProperties } = {
    dateColumn: { width: 150, textAlign: 'left' },
    subjectColumn: { textAlign: 'left' },
    senderColumn: { width: 200, textAlign: 'left' },
    actionsColumn: { width: 110 },
    senderCell: { fontWeight: 'bold' },
    actionsCell: { textAlign: 'right' },
    hidden: { display: 'none' },
    backButton: { marginTop: 10 },
    drawerBody: { padding: 20, height: '100%', overflowY: 'auto' },
    drawerHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    drawerSummary: { fontSize: 17.5 },
    recipientsLink: { paddingLeft: 0 }
};

export const Page = styled.div`
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    padding: 10px 15px 20px;
    color: #1f2933;
`;

export const Title = styled.h1`
    font-size: 20px;
    font-weight: 700;
    margin: 0 0 12px;
`;

export const TitleBar = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    h1 {
        margin: 0;
    }
`;

export const ContactLink = styled.a`
    color: #d32f2f;
    font-size: 14px;
    font-weight: 600;

    &:hover,
    &:focus {
        color: #b71c1c;
    }
`;

export const Card = styled.div`
    background: #fff;
    border: 1px solid #e3e6ea;
    border-radius: 8px;
    padding: 12px 14px;
`;

export const Toolbar = styled.div`
    display: flex;
    gap: 10px;
    margin-bottom: 12px;
`;

export const SearchBox = styled.div`
    flex: 1;
    position: relative;

    .glyphicon {
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        color: #6b7280;
        font-size: 13px;
    }

    input {
        width: 100%;
        height: 34px;
        padding: 0 12px 0 34px;
        border: 1px solid #cfd4da;
        border-radius: 6px;
        font-size: 14px;
        background: #fff;
    }

    input:focus {
        outline: none;
        border-color: #2f6fd1;
    }
`;

export const SenderSelect = styled.select`
    width: 190px;
    height: 34px;
    padding: 0 10px;
    border: 1px solid #cfd4da;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    background: #fff;
`;

export const Table = styled.table`
    width: 100%;
    border: 1px solid #e3e6ea;
    border-radius: 6px;
    border-collapse: separate;
    border-spacing: 0;
    overflow: hidden;

    th {
        background: #f3f4f6;
        padding: 8px 12px;
        font-size: 13px;
        font-weight: 600;
        color: #374151;
        border-bottom: 1px solid #e3e6ea;
        white-space: nowrap;
    }

    td {
        padding: 7px 12px;
        font-size: 14px;
        border-bottom: 1px solid #e3e6ea;
        vertical-align: middle;
    }

    tr:last-child td {
        border-bottom: none;
    }
`;

export const SortButton = styled.button`
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    color: inherit;
    cursor: pointer;

    .glyphicon {
        font-size: 10px;
        margin-left: 6px;
        color: #6b7280;
    }
`;

export const SentDate = styled.div`
    font-weight: 600;

    small {
        display: block;
        font-weight: 400;
        font-size: 12px;
        color: #6b7280;
    }
`;

export const SubjectLink = styled.a`
    color: #2f6fd1;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
`;

export const ViewButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 3px 10px;
    background: #fff;
    border: 1px solid #cfd4da;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    color: #2f6fd1;
    cursor: pointer;

    &:hover {
        background: #f3f6fb;
    }
`;

export const Footer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    font-size: 13px;
    color: #374151;
`;

export const Pager = styled.div`
    display: flex;
    gap: 6px;
    align-items: center;
`;

export const PageButton = styled.button<{ active?: boolean }>`
    min-width: 30px;
    height: 30px;
    padding: 0 6px;
    border: 1px solid ${p => (p.active ? '#2f6fd1' : '#cfd4da')};
    border-radius: 6px;
    background: ${p => (p.active ? '#e8f0fc' : '#fff')};
    color: ${p => (p.active ? '#2f6fd1' : '#374151')};
    font-size: 14px;
    cursor: pointer;

    &:disabled {
        color: #b6bcc4;
        background: #f3f4f6;
        cursor: default;
    }
`;

export const Ellipsis = styled.span`
    min-width: 24px;
    text-align: center;
    color: #6b7280;
`;

export const EmptyRow = styled.td`
    text-align: center;
    color: #6b7280;
    padding: 20px 12px !important;
`;
